export enum CompanyRoutes {
  Root = "",
  ShiftMaker = "shift-maker",
  EmployeeRelationships = "employee-relationships",
  EmployeeRelationshipsSettings = "employee-relationships/settings",
  EmployeeAttributesSettings = "employee-attributes/settings",
  Contracts = 'contracts',
  // Required contact-channel linking (#558, Telegram first) — the manager screen that assigns a channel to an
  // employee / employment-relationship / the whole company, plus the roster's link-state overview.
  ContactRequirements = 'contact-requirements',
  Forms = 'forms',
  FormBuilder = 'forms/builder',
  FormRequirements = 'forms/requirements',
  Submissions = 'forms/submissions',
  SubmissionDetail = 'forms/submissions/:id',
  PayrollInvitations = 'payroll',
  // Scoped role grants + invitations (#261/#279). Named "access" rather than "grants" because that is what the
  // screen is about for the person using it; the API's own noun stays in the models.
  Access = 'access',
  DeviceConfig = 'device-config',
  WorktimeStats = 'worktime-stats'
}
